import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateNoCallsMade = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 507,
	height: 507,
	viewBox: "0 0 507 507",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3315_28940)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M448.062 89.3584V193.293H245.262V89.3584H448.062Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M253.5 507C393.504 507 507 393.504 507 253.5C507 113.496 393.504 0 253.5 0C113.496 0 0 113.496 0 253.5C0 393.504 113.496 507 253.5 507Z",
				fill: "#EBF3FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M103.3 122.314H150.831C169.843 122.314 185.053 137.524 185.053 156.537V405.601H103.933C84.9209 405.601 69.7109 390.391 69.7109 371.378V155.903C69.7109 136.891 84.9209 121.681 103.933 121.681L103.3 122.314Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M140.059 241.459H471.51C481.016 241.459 488.621 249.064 488.621 258.57V370.744C488.621 389.757 473.411 404.967 454.399 404.967H140.059V241.459Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M422.077 226.249H269.344V242.727H422.077V226.249Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M465.173 55.1367H228.15C218.644 55.1367 211.039 62.7417 211.039 72.248V210.405C211.039 219.912 218.644 227.517 228.15 227.517H465.173C474.679 227.517 482.284 219.912 482.284 210.405V72.248C482.284 62.7417 474.679 55.1367 465.173 55.1367Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M143.862 142.594C153.368 142.594 160.973 150.199 160.973 159.705V346.662C160.973 356.168 153.368 363.773 143.862 363.773H109.639C100.133 363.773 92.5278 356.168 92.5278 346.662V159.705C92.5278 150.199 100.133 142.594 109.639 142.594H143.862ZM143.862 133.722H109.639C95.6966 133.722 84.2891 145.129 84.2891 159.072V346.028C84.2891 359.97 95.6966 371.378 109.639 371.378H143.862C157.804 371.378 169.212 359.97 169.212 346.028V159.072C169.212 145.129 157.804 133.722 143.862 133.722Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M226.88 283.287C241.456 283.287 253.497 295.328 253.497 309.904C253.497 324.48 241.456 336.522 226.88 336.522C212.303 336.522 200.262 324.48 200.262 309.904C200.262 295.328 212.303 283.287 226.88 283.287ZM226.88 274.414C207.233 274.414 192.023 290.258 192.023 309.27C192.023 328.283 207.867 344.127 226.88 344.127C245.892 344.127 261.736 328.283 261.736 309.27C261.736 290.258 245.892 274.414 226.88 274.414Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M309.268 271.245H288.988C286.188 271.245 283.918 273.515 283.918 276.315V282.653C283.918 285.453 286.188 287.723 288.988 287.723H309.268C312.068 287.723 314.338 285.453 314.338 282.653V276.315C314.338 273.515 312.068 271.245 309.268 271.245Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M358.065 271.245H337.785C334.985 271.245 332.715 273.515 332.715 276.315V282.653C332.715 285.453 334.985 287.723 337.785 287.723H358.065C360.865 287.723 363.135 285.453 363.135 282.653V276.315C363.135 273.515 360.865 271.245 358.065 271.245Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M406.866 271.245H386.586C383.786 271.245 381.516 273.515 381.516 276.315V282.653C381.516 285.453 383.786 287.723 386.586 287.723H406.866C409.666 287.723 411.936 285.453 411.936 282.653V276.315C411.936 273.515 409.666 271.245 406.866 271.245Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M309.268 306.735H288.988C286.188 306.735 283.918 309.005 283.918 311.805V318.143C283.918 320.943 286.188 323.213 288.988 323.213H309.268C312.068 323.213 314.338 320.943 314.338 318.143V311.805C314.338 309.005 312.068 306.735 309.268 306.735Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M358.065 306.735H337.785C334.985 306.735 332.715 309.005 332.715 311.805V318.143C332.715 320.943 334.985 323.213 337.785 323.213H358.065C360.865 323.213 363.135 320.943 363.135 318.143V311.805C363.135 309.005 360.865 306.735 358.065 306.735Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M406.866 306.735H386.586C383.786 306.735 381.516 309.005 381.516 311.805V318.143C381.516 320.943 383.786 323.213 386.586 323.213H406.866C409.666 323.213 411.936 320.943 411.936 318.143V311.805C411.936 309.005 409.666 306.735 406.866 306.735Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M309.268 342.226H288.988C286.188 342.226 283.918 344.495 283.918 347.296V353.633C283.918 356.433 286.188 358.703 288.988 358.703H309.268C312.068 358.703 314.338 356.433 314.338 353.633V347.296C314.338 344.495 312.068 342.226 309.268 342.226Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M358.065 342.226H337.785C334.985 342.226 332.715 344.495 332.715 347.296V353.633C332.715 356.433 334.985 358.703 337.785 358.703H358.065C360.865 358.703 363.135 356.433 363.135 353.633V347.296C363.135 344.495 360.865 342.226 358.065 342.226Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M406.866 342.226H386.586C383.786 342.226 381.516 344.495 381.516 347.296V353.633C381.516 356.433 383.786 358.703 386.586 358.703H406.866C409.666 358.703 411.936 356.433 411.936 353.633V347.296C411.936 344.495 409.666 342.226 406.866 342.226Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M103.298 404.967H454.395C467.07 404.967 478.478 397.995 484.182 387.855H73.5117C79.2155 397.995 90.623 404.967 103.298 404.967Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M131.185 385.472C131.185 393.153 128.99 399.737 125.698 405.223C128.99 409.613 131.185 416.197 131.185 424.975C131.185 433.754 128.99 439.24 125.698 444.727C128.99 449.116 131.185 455.7 131.185 464.479C131.185 473.257 126.796 487.523 108.141 487.523V480.939C110.336 480.939 124.601 480.939 124.601 464.479C124.601 457.895 123.504 453.506 120.212 449.116C110.336 457.895 97.1679 457.895 97.1679 457.895C97.1679 457.895 93.8759 457.895 90.5839 456.798C86.1946 454.603 84 450.214 84 444.727C84 434.851 91.6813 431.559 97.1679 431.559C102.654 431.559 110.336 431.559 120.212 440.338C122.406 435.949 124.601 431.559 124.601 424.975C124.601 418.391 123.504 414.002 120.212 409.613C110.336 418.391 97.1679 418.391 97.1679 418.391C97.1679 418.391 93.8759 418.391 90.5839 417.294C86.1946 415.099 84 410.71 84 406.321C84 396.445 91.6813 393.153 97.1679 393.153C102.654 393.153 110.336 393.153 120.212 401.932C122.406 397.542 124.601 393.153 124.601 386.569H131.185V385.472ZM92.7786 410.71C92.7786 410.71 92.7786 410.71 93.8759 410.71C96.0705 410.71 97.1679 410.71 97.1679 410.71C97.1679 410.71 108.141 410.71 115.822 404.126C108.141 397.542 97.1679 397.542 97.1679 397.542C96.0705 397.542 90.5839 397.542 90.5839 404.126C90.5839 410.71 90.5839 407.418 91.6813 408.515L92.7786 410.71ZM92.7786 450.214C92.7786 450.214 92.7786 450.214 93.8759 450.214C96.0705 450.214 97.1679 450.214 97.1679 450.214C97.1679 450.214 108.141 450.214 115.822 443.63C108.141 437.046 97.1679 437.046 97.1679 437.046C96.0705 437.046 90.5839 437.046 90.5839 443.63C90.5839 450.214 90.5839 446.922 91.6813 448.019L92.7786 450.214Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M131.185 370.11H124.602V385.473H131.185V370.11Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M104.851 482.037H107.045V488.621H104.851C102.656 488.621 101.559 487.524 101.559 485.329C101.559 483.134 102.656 482.037 104.851 482.037Z",
				fill: "#3F8BFD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M81.7548 15.8439L114.076 72.8814C117.245 78.5852 113.442 86.1902 106.471 86.1902H42.4623C35.4911 86.1902 31.0548 79.2189 34.8573 72.8814L66.5448 15.8439C69.7136 9.50645 78.5861 9.50645 82.3886 15.8439H81.7548Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M74.1484 58.3052V34.2227",
				stroke: "#6BA6FF",
				strokeWidth: 5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 74.1497,
				cy: 70.346,
				r: 3.48563,
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M448.062 89.3584V193.293H245.262V89.3584H448.062Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M324.481 129.285C324.481 124.848 320.679 121.046 316.243 121.046C311.806 121.046 308.004 124.848 308.004 129.285C308.004 133.721 311.806 137.523 316.243 137.523C320.679 137.523 324.481 133.721 324.481 129.285Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M385.321 129.285C385.321 124.848 381.519 121.046 377.082 121.046C372.646 121.046 368.844 124.848 368.844 129.285C368.844 133.721 372.646 137.523 377.082 137.523C381.519 137.523 385.321 133.721 385.321 129.285Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M329.416 148.956C330.684 148.956 331.951 149.59 333.219 150.857C335.754 155.294 340.19 157.829 345.894 157.829C351.597 157.829 355.4 155.294 358.569 150.857C359.836 148.956 362.371 148.322 364.272 149.59C366.174 150.857 366.807 153.392 365.54 155.294C361.737 162.265 354.132 166.701 345.894 166.701C337.655 166.701 330.684 162.265 326.247 155.294C324.98 153.392 326.247 150.857 327.515 149.59C327.515 149.59 328.782 149.59 329.416 149.59V148.956Z",
				fill: "#002F75"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3315_28940",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 507,
			height: 507,
			fill: "white"
		})
	}) })]
});
export default SvgEmptyStateNoCallsMade;
